import { createAction, props } from '@ngrx/store';
import { Tiles } from 'generated/graphql-types';
import { RestApiError, SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { Tile } from 'src/app/pages/tiles/models/tile.model';
import { PreviewDashboardTile } from '../../models/dashboard-tile.model';
import { TileSet } from '../../tile-set-type-select/models/tile-set.model';

export const pageEnter = createAction('[Add Dashboard Tile] Page enter.');

export const loadTileSets = createAction('[Add Dashboard Tile] Load tile sets.');
export const loadTileSetsSuccess = createAction('[API] Load tile sets success.', props<{ tileSets: TileSet[] }>());
export const loadTileSetsFailure = createAction('[API] Load tile sets failure.', props<SingleGraphError>());

export const searchTextChange = createAction(
   '[Add Dashboard Tile] Search text changed.',
   props<{ searchText: string }>()
);

export const openSelectedAddTileDialog = createAction(
   '[Add Dashboard Tile] Open Selected Add Tile Dialog.',
   props<{ tile: Tile }>()
);

export const addTile = createAction(
   '[Add Dashboard Tile] Add tile',
   props<{ previewTileConfig: PreviewDashboardTile | null; params: any }>()
);
export const addTileSuccess = createAction(
   '[API] Add tile success',
   props<{
      dashboardTileId: number | null;
      tileId: Tiles;
   }>()
);
export const addTileFailure = createAction('[API] Add tile failure', props<RestApiError>());

export const loadPreviewTile = createAction(
   '[Add Dashboard Tile] Load preview tile',
   props<{ previewTileConfig: PreviewDashboardTile }>()
);

export const setLastAddedTileId = createAction(
   '[Add Dashboard Tile] Set last added tile id',
   props<{ id: number | null }>()
);
